import { render, staticRenderFns } from "./GvsDeleteDialog.vue?vue&type=template&id=f01f1a7e"
import script from "./GvsDeleteDialog.vue?vue&type=script&lang=js"
export * from "./GvsDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports